import settings from '../../config/settings';
import axiosNonAuth from './axiosNonAuth';

const {apiBaseUrl} = settings;

export default class RedirectPreferenceApi {
  static set({fingerprint: fingerprintOld, fingerprint2}, preference) {
    return axiosNonAuth.post(`${apiBaseUrl}/redirect-preferences/`, {
      fingerprint: fingerprint2,
      fingerprintOld,
      preference
    });
  }

  static get(fingerprint2, fingerprintOld) {
    const params = fingerprintOld ? {fingerprintOld} : null;
    return axiosNonAuth.get(`${apiBaseUrl}/redirect-preferences/${fingerprint2}/`, {params})
      .then(response => (response.preference));
  }
}
